import React from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import { Icon, Modal as OriginalModal } from "semantic-ui-react";

import ModalTracker from "components/Modal/modalTracker";

export const useHeaderStyles = makeStyles({
  header: {
    "&": {
      position: "relative",
      textAlign: ({ titleAlign }) => {
        return titleAlign;
      },
      paddingRight: 0,
    },
    "& > div > i": {
      position: "absolute",
      right: "17px",
      cursor: "pointer",
    },
  },
});

const ModalHeader = ({
  titleAlign,
  subtitle,
  disabled,
  style,
  children,
  onClose,
}) => {
  const headerClasses = useHeaderStyles({ titleAlign });
  return (
    <OriginalModal.Header className={headerClasses.header}>
      <div style={{ display: "flex" }}>
        <div style={{ flexGrow: 1, paddingRight: "15px" }}>
          <div>
            {children}
            {subtitle && (
              <div
                style={{
                  fontSize: "72%",
                  fontWeight: "normal",
                  ...style,
                }}
                data-test="modal-subtitle"
              >
                {subtitle}
              </div>
            )}
          </div>
        </div>
        {onClose && (
          <Icon
            name="close"
            disabled={disabled}
            style={{ cursor: disabled ? "default" : "pointer" }}
            onClick={onClose}
            data-test="modal-close-button"
          />
        )}
      </div>
    </OriginalModal.Header>
  );
};

ModalHeader.propTypes = {
  titleAlign: PropTypes.oneOf(["left", "center"]),
  subtitle: PropTypes.string,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  children: PropTypes.node,
  onClose: PropTypes.func,
};

ModalHeader.defaultProps = {
  titleAlign: "left",
  children: null,
  disabled: false,
  subtitle: "",
  style: {},
  onClose: () => {},
};

export function ModalHeaderWithTracker({ onClose, ...props }) {
  return (
    <ModalHeader
      {...props}
      onClose={() => {
        ModalTracker.decrement();
        onClose();
      }}
    />
  );
}

ModalHeaderWithTracker.propTypes = {
  onClose: PropTypes.func,
};

ModalHeaderWithTracker.defaultProps = {
  onClose: () => {},
};

export default ModalHeader;
